import { render, staticRenderFns } from "./SelectTaskChatSession.vue?vue&type=template&id=6654877e&scoped=true&"
import script from "./SelectTaskChatSession.vue?vue&type=script&lang=js&"
export * from "./SelectTaskChatSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6654877e",
  null
  
)

export default component.exports